import { Tag } from 'antd'
import { FC, ReactNode } from 'react'
import { RewindJobStatuses } from '../../../../types/api/rewind-job'

interface JobStatusCellProps {
    jobStatus: RewindJobStatuses | string
}

const JobStatusCell: FC<JobStatusCellProps> = ({ jobStatus }) => {
    const jobStatusesViews: Record<string, ReactNode> = {
        [RewindJobStatuses.Rewinding]: <Tag color='blue'>{RewindJobStatuses.Rewinding}</Tag>,
        [RewindJobStatuses.Created]: <Tag color='cyan'>{RewindJobStatuses.Created}</Tag>,
        [RewindJobStatuses.Planned]: <Tag color='geekblue'>{RewindJobStatuses.Planned}</Tag>,
        [RewindJobStatuses.Completed]: <Tag color='green'>{RewindJobStatuses.Completed}</Tag>,
        [RewindJobStatuses.Cancelled]: <Tag color='red'>{RewindJobStatuses.Cancelled}</Tag>,
    }

    return <>{jobStatusesViews[jobStatus] ?? jobStatus}</>
}

export default JobStatusCell
